<template>
  <div class="signup-wizard">
    <div v-if="showBackButton" @click="back()" class="back">
      <ArrowLeftIcon />
      <span class="back-text">BACK</span>
    </div>
    <div class="steps-container">
      <AddArtistWizardStepAddArtist
        v-if="currentStep === 1"
        @close="close()"
        @nextStep="nextStep"
      />
      <AddArtistWizardStepAddAnotherArtist
        v-if="currentStep === 2"
        @close="close()"
        @nextStep="nextStep"
        @setStep="setStep"
      />
      <AddArtistWizardStepSelectPlan
        v-if="currentStep === 3"
        @close="close()"
        @nextStep="nextStep"
        @setStep="setStep"
      />
      <AddArtistWizardStepBilling
        v-if="currentStep === 4"
        @close="close()"
        @nextStep="nextStep"
      />
      <AddArtistWizardStepFinished
        v-if="currentStep === 5"
        @close="close()"
        @nextStep="nextStep"
        @finish="onFinish()"
      />
    </div>
    <SnackBar>
      <template v-slot:icon></template>
    </SnackBar>
  </div>
</template>
<script>
import ArrowLeftIcon from "../../../public/img/icons/arrow-left.svg";
import AddArtistWizardStepAddArtist from "@/components/Custom/AddArtistWizardStepAddArtist";
import AddArtistWizardStepAddAnotherArtist from "@/components/Custom/AddArtistWizardStepAddAnotherArtist";
import AddArtistWizardStepSelectPlan from "@/components/Custom/AddArtistWizardStepSelectPlan";
import AddArtistWizardStepBilling from "@/components/Custom/AddArtistWizardStepBilling";
import AddArtistWizardStepFinished from "@/components/Custom/AddArtistWizardStepFinished";
import SnackBar from "@/components/Custom/SnackBar";
import { mapState } from "vuex";
import { Q_GET_USER } from "@/graphql";
export default {
  name: "AddArtistWizard",
  components: {
    ArrowLeftIcon,
    AddArtistWizardStepAddArtist,
    AddArtistWizardStepAddAnotherArtist,
    AddArtistWizardStepSelectPlan,
    AddArtistWizardStepBilling,
    AddArtistWizardStepFinished,
    SnackBar
  },
  data() {
    return {
      // currentStep: 1
    };
  },
  async mounted() {
    this.$store.commit("addArtist/reset");
    if (!this.$store.getters.getUser?.master_account_id) {
      try {
        const result = await this.$apollo.query({
          query: Q_GET_USER,
          client: "localClient",
          fetchPolicy: "network-only"
        });
        const freshUser = result.data.get_current_user_data?.user;
        if (freshUser?.master_account_id) {
          await this.$store.dispatch("setUser", freshUser);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    ...mapState("addArtist", ["currentStep"]),
    showBackButton() {
      return [2, 3, 4].includes(this.currentStep);
    }
  },
  methods: {
    setStep(step) {
      this.$store.commit("addArtist/setStep", step);
    },
    async nextStep() {
      this.$store.commit("addArtist/nextStep");
    },
    async onFinish() {
      console.log("finished");
      await this.$router.push({ name: "SmartLinks" });
    },
    back() {
      this.$store.commit("addArtist/previousStep");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.signup-wizard {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* BG/type1 */
  //background: $bg-type-1;
  border-radius: 10px;
  position: relative;
  .steps-container {
    flex: 1;
    display: flex;
    justify-content: center;
    // overflow-y: auto;
    //padding: 60px 0;
  }
  .back {
    cursor: pointer;
    position: absolute;
    top: 66px;
    left: 66px;
    display: flex;
    //flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .back-text {
        color: white;
      }
    }
    svg {
      width: 28px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .back-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
}
</style>
